//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ClientListConfig
export const EmployeeFundsSearchLedgerConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/ewa/searchLedger",
      component: FuseLoadable({
        loader: () => import("./SearchLedger.js")
      })
    }
  ]
  //end routes
};
